import { render, staticRenderFns } from "./costHelpSpa.vue?vue&type=template&id=50481aa4&"
import script from "./costHelpSpa.vue?vue&type=script&lang=js&"
export * from "./costHelpSpa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50481aa4')) {
      api.createRecord('50481aa4', component.options)
    } else {
      api.reload('50481aa4', component.options)
    }
    module.hot.accept("./costHelpSpa.vue?vue&type=template&id=50481aa4&", function () {
      api.rerender('50481aa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2haB0fdQBaF5U/JS/comp/costHelpSpa.vue"
export default component.exports